import axiosInstance from './axiosInstance';

// Create a new company
export const createCompany = (data) => axiosInstance.post('/companies', data);

// Get all companies
export const getCompanies = () => axiosInstance.get('/companies');

// Get a company by ID
export const getCompanyById = (id) => axiosInstance.get(`/companies/${id}`);

// Update a company by ID
export const updateCompany = (id, data) =>
	axiosInstance.put(`/companies/${id}`, data);

// Delete a company by ID
export const deleteCompany = (id) => axiosInstance.delete(`/companies/${id}`);

// Get company settings
export const getCompanySettings = (companyId) =>
	axiosInstance.get(`/companies/${companyId}/settings`);

// Update company settings
export const updateCompanySettings = (companyId, settings) =>
	axiosInstance.put(`/companies/${companyId}/settings`, { settings });
